export const RTL_LANGUAGES: string[] = ['ar', 'ur', 'he'];
